export const publishersBasePath = 'fournisseurs';
export const PUBLISHERS_LIST = `/${publishersBasePath}/liste`;
export const PUBLISHERS_REMINDER_LIST = `/${publishersBasePath}/rappels`;
export const SUB_TAB_ROUTER_PARAMETER = 'fournisseurSubTab';
